import { getRelativePath } from 'base/shared/Utils';

const BASE_PATH = '/favorites';

export const getFavoritesPath = () => getRelativePath(BASE_PATH);
